import type { Patient, Reference } from '@medplum/fhirtypes'
import { createContext } from 'react'

// The participant an editor is writing about, as its node views (which render
// inside the editor's React tree) should see it now: a reference, `null` for
// "explicitly no participant", or `undefined` where the editor does not say
// (the route's participant applies). Provided around EditorContent, so it
// follows the editor's `participant` prop, which extension options set at
// construction do not.
export const EditorParticipantContext = createContext<
  Reference<Patient> | null | undefined
>(undefined)
